import React from 'react';
import Notification from '../../Shared/Notifications';
import ClipLoader from "react-spinners/ClipLoader";
import {getRules} from '../rules/services/rules';
import {newUser} from './services/users';
import { BUTTON_LINE_ICON } from '../../Shared/Constants';
import { ToastContainer, toast } from 'react-toastify';
class NewUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            username: '',
            password: '',
            passwordConfirm: '',
            role: 0,
            showNotification: false,
            disabledButton: false,
            loading: true,
            isUpdate: false,
        };
    }

    componentDidMount() {
        this.getGroups();
    }

    endUserCreation = () => {
        let body;
        if(this.state.isUpdate) {
            if(this.state.username === '' && this.state.passW !== '') {
                return toast('Por favor digite el nombre de usuario y contraseña antes de continuar');
            }
            body = {
                id:this.props.user.pks,
                name: this.state.name,
                idType:3,
                userName:this.state.username,
                email:this.state.email,
                active:true,
                roleName: this.getRoleById(parseInt(this.state.role)),
                IdtypeUser:3,
                passW:this.state.password,
            }
        }else{
            body = {
                name: this.state.name,
                idType:3,
                userName:this.state.username,
                passW:this.state.password,
                email:this.state.email,
                active:true,
                IdtypeUser:3,
                roleName: this.getRoleById(parseInt(this.state.role)),
            }
        }
        this.processData(body)
    }

    processData = (body) => {
        this.setState({loading: true, disabledButton:true});
        newUser(body).then((result) => {
            toast(result.data.message);
            this.props.closeDialog();
            this.setState({loading:false})
        }).catch((error) => {
            console.log("el error", error);
            toast(error);
            this.setState({loading:false})
        });
    }

    getRoleById = (id) => {
        if(id === 0) {
            return null;
        }
        let role = this.state.rules.find((rule) => rule.id === id);
        return role.roleName;
    }

    getRoleByName = (name) => {
        /// let role = this.state.rules.find((rule) => rule.roleName === name);
        /// return role.id;
    }

    renderNotification = () => {
        return(
            <Notification 
                show={this.state.showNotification}
                title={'Datos almacenados'}
                subtitle={'Sus datos fueron almacenados correctamente.'}
            />
        )
    }

    getGroups = () => {
        getRules({id:null,roleName:null, limit:500}).then((response) => {
           if(response) {
                const data = response.data.data.filter((item) => item.id !== 3);
                let id = 0;
                this.setState({rules: data});
                if(this.props.user) {
                    data.forEach(element => {
                        if (element.roleName && this.props.user.roleName) {
                            if (element.roleName.trim().toLowerCase() === this.props.user.roleName.trim().toLowerCase()) {
                                id = element.id
                            }
                          } else {
                             
                          }
                    });
                    this.setState({
                        isUpdate:true,
                        name:this.props.user.name,
                        idType:this.props.user.idType,
                        active: this.props.user.active,
                        username: this.props.user.userName,
                        email: this.props.user.email,
                        role: id
                    });
                }
           }

           this.setState({loading: false});
        })
    }

    render() {
        return(
            <div className='space-y-12'>
                {
                    this.state.loading ? 
                        <center>
                            <ClipLoader
                                color={'gray'}
                                loading={true}
                                size={50}
                                aria-label="Loading Spinner"
                                data-testid="loader"/>
                        </center>
                        :
                        <div>
                            <div className="border-b border-gray-900/10 pb-12">
                                <h2 className="text-base/7 font-semibold text-gray-900">Datos Personales</h2>
                                <p className="mt-1 text-sm/6 text-gray-600">
                                    Esta informacion es completamente confidencial, asegurese de ingresar los datos correctamente.
                                </p>
                                <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                                    <div className="sm:col-span-4">
                                        <label htmlFor='fullname' className="text-base/7 font-semibold text-gray-900">
                                            Nombre Completo
                                        </label>
                                        <div className="mt-2">
                                            <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-gray-600 sm:max-w-md">
                                                    <input
                                                        value={this.state.name}
                                                        onChange={(event) => {this.setState({name: event.target.value})}}
                                                        id="fullname"
                                                        name="fullname"
                                                        type="text"
                                                        placeholder=""
                                                        autoComplete=""
                                                        className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm/6"
                                                    />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sm:col-span-4">
                                        <label htmlFor='fullname' className="text-base/7 font-semibold text-gray-900">
                                            Nombre de usuario
                                        </label>
                                        <div className="mt-2">
                                            <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-gray-600 sm:max-w-md">
                                                    <input
                                                        value={this.state.username}
                                                        onChange={(event) => {this.setState({username: event.target.value})}}
                                                        id="fullname"
                                                        name="fullname"
                                                        type="text"
                                                        placeholder=""
                                                        autoComplete=""
                                                        className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm/6"
                                                    />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sm:col-span-4">
                                        <label htmlFor='email' className="text-base/7 font-semibold text-gray-900">
                                        Dirección de correo electrónico
                                        </label>
                                        <div className="mt-2">
                                            <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-gray-600 sm:max-w-md">
                                                    <input
                                                        value={this.state.email}
                                                        onChange={(event) => {this.setState({email: event.target.value})}}
                                                        id="email"
                                                        name="email"
                                                        type="text"
                                                        placeholder=""
                                                        autoComplete=""
                                                        className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm/6"
                                                    />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                                    <div className="border-b border-gray-900/10 pb-12">
                                        <h2 className="text-base/7 font-semibold text-gray-900">Datos de inicio de sesión</h2>
                                        <p className="mt-1 text-sm/6 text-gray-600">
                                            Por favor diligencie una contraseña segura y el grupo al que pertenecera el tendra el usuario
                                        </p>
                                        <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                                            <div className="sm:col-span-4">
                                                <label htmlFor='password' className="text-base/7 font-semibold text-gray-900">
                                                    Contraseña
                                                </label>
                                                <div className="mt-2">
                                                    <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-gray-600 sm:max-w-md">
                                                            <input
                                                                value={this.state.password}
                                                                onChange={(event) => {this.setState({password: event.target.value})}}
                                                                name={`randomName${Math.random()}`}
                                                                type="text"
                                                                autocomplete="new-password"
                                                                className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm/6"
                                                            />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            
                            <div className="border-b border-gray-900/10 pb-12">
                                <p className="mt-1 text-sm/6 text-gray-600" style={{textAlign:'justify'}}>
                                Por favor indicar que permisos y que accesos tendrá el usuario, estos permisos le darán los accesos necesarios configurables para los diferentes módulos del sistema, si desea saber más acceda al módulo de Grupos
                                </p>

                                <div className="mt-10 space-y-10">
                                    <fieldset>
                                        <div className="mt-6 space-y-6">
                                            <div>
                                                <label htmlFor="location" className="block text-sm/6 font-medium text-gray-900">
                                                    Seleccione Grupo
                                                </label>
                                                <select
                                                    value={this.state.role}
                                                    onChange={(event) => {this.setState({role: event.target.value})}}
                                                    id="location"
                                                    name="location"
                                                    defaultValue="Canada"
                                                    className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-gray-600 sm:text-sm/6"
                                                >
                                                    <option key={0} value={0} selected>SELECCIONAR </option>
                                                    {
                                                        this.state.rules?.map((item) => {
                                                            return(
                                                                <option key={item.id} value={item.id}>{item.roleName}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                            <div style={{paddingTop:50}}>
                                <button 
                                    onClick={() => {this.endUserCreation()}}
                                    type="button"
                                    className={BUTTON_LINE_ICON}>
                                    FINALIZAR
                                </button>
                                <button  
                                    className='bg-white text-gray-900'
                                    style={{marginLeft:10}}                  
                                    onClick={() => {this.props.closeDialog()}}
                                    type="button"
                                >
                                    CANCELAR
                                </button>
                            </div>
                            {this.renderNotification()}
                        </div>
                }
                <ToastContainer position="top-center" hideProgressBar={true}/>  
            </div>
        )
    }  
}

export default NewUser;